/* template */
<template><div class="mpx-root-view"><div :style="[(warpStyle2)] | transRpxStyle" class="warp"><template v-if="(!error)"><mpx-text :style="[(ruleStyle)] | transRpxStyle" @tap="gotoLink(signVersion.rule.link)" class="rule">规则</mpx-text><red-packet-sign :config="(signVersion.redPacket)" :btnText="(btnText)" :couponList="(couponList)" @click="getCoupon" v-if="(activityCouponInfo)"/><sunflower-code :config="(signVersion.code)" :codeImageUrl="(sunflowerCodeImage)" :hasGetCoupon="(hasGetCoupon)" @savePosterImg="savePosterImg"/><poster-popup :popupData="(posterPopup.data)" @closePosterPopup="closePopup('posterPopup')" v-if="(posterPopup.show)"/><result-popup :popupData="(resultPopup.data)" @savePoster="resultPopupSavePoster" @closeResultPopup="closePopup('resultPopup')" v-if="(resultPopup.show)"/><div class="footer"><res-banner :template="(info.template)" version="sign-in" v-if="(activityCouponInfo)"/></div><div class="notice">- 本活动由滴滴出行推送 -</div></template><error-view :error="(error)" :message="(errmsg)" v-else/></div><toast :icon="(toast.icon)" :content="(toast.content)" v-if="(toast.show)"/></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"md5ca0498"}'>
// 0123456789.¥
@font-face {
  font-family: DIN-BlackItalic-self
  src: url('https://dpubstatic.udache.com/static/dpubimg/AXmjyhbZbCBZvHajSpoVQ.ttf')
}
// 元折去打车周一二三四五六日可领券包立即取每天都能领打车神券保存海报 !  明天再领 !  每天可领 !打车前必领！!
@font-face {
  font-family: MF-YuanHei-Regular-self
  src: url('https://dpubstatic.udache.com/static/dpubimg/c5UtBlWU-9WDlUg5N-xne.ttf')
}
@font-face {
  font-family: UniSansHeavyCapsItalic-self
  src: url('https://dpubstatic.udache.com/static/dpubimg/d6b47ca2-a4d2-4f84-8864-9040aa6965b5.otf')
}
// 周五六日低至折
@font-face {
  font-family: AlibabaPuHuiTi-Heavy-self
  src: url('https://dpubstatic.udache.com/static/dpubimg/dhnzXchaoOlA3jZz6rsxq.ttf')
}
  .warp
    min-height 100vh
    width 100vw
    overflow hidden
    box-sizing: border-box;
    background-size 100vw auto
    background-repeat no-repeat
    line-height: normal;
    position relative
    .rule
      box-sizing border-box
      position absolute
      right -1px
      z-index 2
      font-family: PingFangSC-Medium;
      background-image: linear-gradient(180deg, rgba(255,255,255,0.00) 0%, rgba(255,238,172,0.48) 100%);
      border-radius: 22.5rpx 0px 0px 22.5rpx
      font-size: 24rpx;
      letter-spacing: 2.67rpx;
      font-weight: bold
      height 40rpx
      line-height 40rpx
      padding 0 14rpx 0 22rpx
      border 1px solid rgba(255, 248, 218, .55)
    .footer
      padding 6rpx 0 177rpx
      background-image: linear-gradient(180deg, #FEE4BF 0%, #FFF5E4 100%);
    .notice
      position absolute
      bottom 30rpx
      left 50%
      transform translateX(-50%)
      font-family: PingFangSC-Regular;
      font-size: 20rpx;
      color: #5A5A5A;
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "md5ca0498"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index-sign.mpx.js?isComponent&outputPath=components%2Findex-signd5ca0498%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./index-sign.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Findex-signd5ca0498%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["md5ca0498"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index-signd5ca0498/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'res-banner':getComponent(require("../../components/common/res-banner.mpx?isComponent&outputPath=components%2Fres-banner12bfcde6%2Findex")),'error-view':()=>import(/* webpackChunkName: "error-view" */"../../components/common/error-view.mpx?async=error-view&isComponent&outputPath=components%2Ferror-view6fe98fb7%2Findex").then(res => getComponent(res)),'toast':getComponent(require("../../components/common/toast.mpx?isComponent&outputPath=components%2Ftoastac0d13f0%2Findex")),'red-packet-sign':getComponent(require("../../components/wyc/red-packet-sign.mpx?isComponent&outputPath=components%2Fred-packet-sign69b974a1%2Findex")),'sunflower-code':getComponent(require("../../components/wyc/sunflower-code.mpx?isComponent&outputPath=components%2Fsunflower-codefd045c34%2Findex")),'poster-popup':getComponent(require("../../components/wyc/popup/poster-popup.mpx?isComponent&outputPath=components%2Fposter-popup05d09a42%2Findex")),'mpx-text':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-text.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
